<template>
	<div :class="['inner-area',{
		'jdy-solid-box':borderStyle=='solid'||!borderStyle,
		'jdy-dotted-box':borderStyle=='dotted',
		'jdy-dashed-box':borderStyle=='dashed'
	}]" :style="{'background':areaColor}">
		<header class="jdy-inner-title" v-if='showTitle' :style='{"background":titleColor }'>
		    <slot name='area-title'></slot>
		</header>
		<el-scrollbar :style='{"height": contentHeight ? contentHeight : showTitle ? "calc(100% - 41px)" : "100%" }'>
			<section class="jdy-inner-body" :style="{'padding':nopadding}">
				<slot name='area-body'></slot>
			</section>
		</el-scrollbar> 
	</div>
</template>
<script>
	export default {
		name:'inner-area',
		props:['no-padding','hide-title','border','content-height','area-color','title-color'],
		data(){
			this.border;
			let me = this;
		 	let showTitleVal;
		 	let nopaddingVal;
		 	let borderVal;

		 	showTitleVal = (me.hideTitle === "" || !!me.hideTitle) ? false : true;
			nopaddingVal = (me.noPadding === "" || !!me.noPadding) ? 0 : '15px 20px';
			borderVal = me.border;

			return {
				showTitle:showTitleVal,
				nopadding: nopaddingVal,
				borderStyle:borderVal
			}
		}
	}
</script>

<style>
	.special-margin{
		margin:0 -10px;
		padding: 0 10px;
		border-bottom-color:#ddd 
	}
</style>



// WEBPACK FOOTER //
// src/components/inner-area.vue